import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RatingModule } from 'primeng/rating';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { Product, ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { InputDialogComponent } from '../input-dialog/input-dialog.component';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../../services/notification.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QrProductFeedback } from '../../../store/app.actions';

@Component({
  selector: 'app-rating',
  imports: [RatingModule, CommonModule],
  templateUrl: './rating.component.html',
  providers: [
    DialogService
  ],
})
export class RatingComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;
  @Input({ required: true }) product!: Product;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  tenantId: string = 'regenesis';
  ref: DynamicDialogRef | null = null;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    this.tenantId = this.route.snapshot.queryParams['x-tenant-id'] || 'regenesis';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  submitRating(event: any) {
    this.ref = this.dialogService.open(InputDialogComponent, {
      width: '90%',
      showHeader: false,
      modal: true,
    });

    if (this.ref) {
      this.ref.onClose.subscribe((result: string | null) => {
        if (result) {
          this.qrCodeFeedback(result, event.value)
        }
      });
    }
  }

  qrCodeFeedback(email: string, rating: number) {
    this.store.dispatch(
      new QrProductFeedback({
        type: 'RATING',
        email,
        user_rate: rating,
        total_rate: 5,
        qrProductItemId: this.product.qrProductItem.id
      }, this.tenantId)
    )
  }
}
